import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SearchSection from './components/SearchSection';
import CategorySection from './components/CategorySection';
import ValueSection from './components/ValueSection';
import PillarArticles from './components/PillarArticles';
import HomeProductsSection from './components/HomeProductsSection';
import InfoSection from './components/InfoSection';
import MainSiteCTA from './components/MainSiteCTA';
import FinalCtaSection from './components/FinalCtaSection';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('meta.homeTitle');
  }, [t]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <SearchSection />
        <MainSiteCTA />
        <HomeProductsSection />
        <CategorySection />
        <ValueSection />
        <PillarArticles />
        <InfoSection
          type="review"
          imageUrl="https://readdy.ai/api/search-image?query=Person%20reviewing%20products%20on%20tablet%20in%20cozy%20modern%20cafe%20with%20warm%20coffee%20cup%20soft%20ambient%20lighting%20lifestyle%20editorial%20photography%20no%20text%20no%20brands&width=800&height=600&seq=info-review-002&orientation=landscape"
        />
        <InfoSection
          type="shipping"
          imageUrl="https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20with%20fragile%20tape%20in%20organized%20warehouse%20with%20warm%20overhead%20lighting%20logistics%20photography%20no%20text%20no%20brands&width=800&height=600&seq=info-shipping-002&orientation=landscape"
        />
        <InfoSection
          type="coupon"
          imageUrl="https://readdy.ai/api/search-image?query=Vintage%20gift%20voucher%20and%20discount%20cards%20on%20mahogany%20desk%20with%20warm%20lamp%20light%20promotional%20product%20photography%20no%20text%20no%20brands&width=800&height=600&seq=info-coupon-002&orientation=landscape"
        />
        <InfoSection
          type="warehouse"
          imageUrl="https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20shelving%20and%20warm%20LED%20lighting%20industrial%20interior%20photography%20clean%20aesthetic%20no%20text%20no%20brands&width=800&height=600&seq=info-warehouse-002&orientation=landscape"
        />
        <InfoSection
          type="legit"
          imageUrl="https://readdy.ai/api/search-image?query=Padlock%20and%20security%20key%20on%20glass%20desk%20with%20soft%20bokeh%20background%20minimal%20trust%20concept%20photography%20no%20text%20no%20brands&width=800&height=600&seq=info-legit-002&orientation=landscape"
        />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}